module.exports = __webpack_public_path__ + "static/media/openclaw.bfec528b.png";